/**
 * Phase 14-E + 14a-4 — audit-event admin viewer schemas.
 *
 * Single global viewer `/admin/audit` with the 14-E locked 8-field
 * filter set; the same shape is reused for per-entity drilldowns at
 * 14b (where `entityType + entityId` are fixed by the detail page).
 *
 * Convention 06 — admin namespace folder; this file owns the audit-
 * viewer surface (separate from the dashboard surface).
 */
import { z } from 'zod';
/** 8-field filter set per 14-E. Standard pagination shape mirrors
 *  `RefundListQuerySchema` / `NotificationListQuerySchema` precedent. */
export const AuditAdminListQuerySchema = z.object({
    actorUserId: z.string().uuid().optional(),
    /** Free-form match on the action string. Specific actions (e.g.
     *  `payout.cycle_close.failed`) are the most common operator query. */
    action: z.string().min(1).optional(),
    entityType: z.string().min(1).optional(),
    entityId: z.string().uuid().optional(),
    /** ISO date (YYYY-MM-DD); inclusive lower bound. */
    fromDate: z.string().date().optional(),
    /** ISO date (YYYY-MM-DD); inclusive upper bound (end-of-day on backend). */
    toDate: z.string().date().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
/** Compact list item — the row payload is intentionally `unknown` to
 *  avoid pretending every action carries the same shape. UI renders a
 *  collapsible JSON view per row. */
export const AuditAdminListItemSchema = z.object({
    id: z.string().uuid(),
    actorUserId: z.string().uuid().nullable(),
    action: z.string(),
    entityType: z.string().nullable(),
    entityId: z.string().uuid().nullable(),
    payload: z.unknown(),
    ipAddress: z.string().nullable(),
    ts: z.string().datetime(),
});
export const AuditAdminListResponseSchema = z.object({
    items: z.array(AuditAdminListItemSchema),
    page: z.number().int().min(1),
    limit: z.number().int().min(1),
    totalCount: z.number().int().min(0),
});
//# sourceMappingURL=audit.schema.js.map